// Singleton-Bus für die aktive LocateControl-Instanz.
//
// Warum: MapPage muss die Control imperativ ansprechen ("Ride-Button → force
// zoom + re-lock"), ohne dass wir die Instance durch die React-Component-Tree
// prop-drillen müssen. MapView published die Instance beim Mount, MapPage
// reads sie wenn sie sie braucht.
//
// Gleiches Pattern wie mapBus / positionBus — kein State-Management-Framework
// nötig, wir haben exakt 1 Map + exakt 1 LocateControl zur selben Zeit.

import type { LocateControl } from './LocateControl';

let current: LocateControl | null = null;
const listeners = new Set<(c: LocateControl | null) => void>();

export const locateControlBus = {
  get(): LocateControl | null {
    return current;
  },
  set(c: LocateControl | null): void {
    if (current === c) return;
    current = c;
    listeners.forEach((fn) => fn(c));
  },
  subscribe(fn: (c: LocateControl | null) => void): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};
